/**
 * Messaging state — Zustand store.
 * Tracks active conversation, draft messages per conversation.
 */
import { create } from 'zustand'

interface MessagingStoreState {
  activeConversationId: string | null
  draftMessages: Record<string, string>

  setActiveConversation: (id: string | null) => void
  setDraft: (conversationId: string, text: string) => void
  clearDraft: (conversationId: string) => void
  reset: () => void
}

const initialState = {
  activeConversationId: null,
  draftMessages: {} as Record<string, string>,
}

export const useMessagingStore = create<MessagingStoreState>((set) => ({
  ...initialState,

  setActiveConversation: (id) => set({ activeConversationId: id }),

  setDraft: (conversationId, text) =>
    set((state) => ({
      draftMessages: { ...state.draftMessages, [conversationId]: text },
    })),

  clearDraft: (conversationId) =>
    set((state) => {
      const next = { ...state.draftMessages }
      delete next[conversationId]
      return { draftMessages: next }
    }),

  reset: () => set(initialState),
}))
